import React from "react";
import { NavLink } from "react-router-dom";

// import { IoMdSettings } from "react-icons/io";
// import { IoPersonSharp } from "react-icons/io5";

import Box from "@mui/material/Box";
import ActionButton from "./ActionButton";

// import setting_svg from "../assets/svg/settings.svg";
import user_svg from "../assets/svg/user.svg";

const PageHeader = ({ children }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
      {children}

      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* <NavLink to="/settings">
          <ActionButton sx={{ boxShadow: "none", margin: "0 20px 0 0" }}>
            <img src={setting_svg} alt="settings" />
            <p>Settings</p>
          </ActionButton>
        </NavLink> */}

        <NavLink to="/account">
          <ActionButton sx={{ margin: "0", backgroundColor: "white" }}>
            <img src={user_svg} alt="profile" />
            <p>Profile</p>
          </ActionButton>
        </NavLink>
      </Box>
    </Box>
  );
};

export default PageHeader;
